import { Directive } from '@angular/core';

@Directive({
  selector: '[irisHeaderSearchResultCardSecondaryIcon]',
  standalone: false,
})
export class IrisHeaderSearchResultCardSecondaryIconDirective {
}
